export default {
    name: "ChatConnectionError",
    components: {
    },
    props: {
    },
    setup() {

    }
}